import { request } from "../../helpers/request";
import { createAsyncThunk } from "@reduxjs/toolkit";

export const getAllCertificates = createAsyncThunk(
  'certificates/list',
  async (_, { rejectWithValue }) => {
    try {
      const data = await request.get('/certificate/list');

      return data;
    } catch (e) {
      rejectWithValue(e);
    }
  }
)